import { useRef, useState } from 'react'

type UpdateDebouncedState<T> = (value: T) => void

export function useDebouncedState<T>(
  initialValue: T,
  delay: number
): [T, T, UpdateDebouncedState<T>] {
  const [value, setValue] = useState(initialValue)
  const [debouncedValue, setDebouncedValue] = useState(initialValue)
  const timerRef = useRef<number | undefined>(undefined)

  const update = (newValue: T) => {
    setValue(newValue)
    window.clearTimeout(timerRef.current)
    timerRef.current = window.setTimeout(() => {
      setDebouncedValue(newValue)
    }, delay)
  }

  return [value, debouncedValue, update]
}
